import { render, staticRenderFns } from "./manager-scorecard.vue?vue&type=template&id=0384389e&scoped=true&"
import script from "./manager-scorecard.vue?vue&type=script&lang=js&"
export * from "./manager-scorecard.vue?vue&type=script&lang=js&"
import style0 from "./manager-scorecard.vue?vue&type=style&index=0&id=0384389e&scoped=true&lang=css&"
import style1 from "./manager-scorecard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384389e",
  null
  
)

export default component.exports